import React, { useEffect, useState } from 'react';
import DashboardCard, { type DashboardCardSize } from 'components/DashboardCard/DashboardCard';
import StorageIcon from '@mui/icons-material/Storage';
import api from 'api';

export type StorageProps = {
    size?: DashboardCardSize;
};

const Storage = ({ size = 'xs' }: StorageProps) => {
    const [label, setLabel] = useState('Loading information...');
    const [message, setMessage] = useState(' ');

    useEffect(() => {
        async function fetchQuota() {
            const result = await api.get('/files/quota');
            const quota = result.data.quota;
            const percentage = (Number(quota.quota_used) / Number(quota.quota_total)) * 100;

            setLabel(`${quota.quota_used} of ${quota.quota_total}GB Used`);
            setMessage(`You're using ${percentage.toFixed(1)}% of your storage.`);
        }

        fetchQuota().catch((err) => console.log(err));
    }, []);

    return (
        <DashboardCard color="lightBlue" icon={<StorageIcon />} topLabel={label} topContent="Storage" size={size}>
            {message}
        </DashboardCard>
    );
};

export default Storage;
